import React, {useEffect} from 'react';
import { useParams } from "react-router-dom";

import Lived from '../subpages/prework/Lived.js';
// import Output from '../subpages/live/Output.js';
import Output from '../subpages/live/Output2.js';
import MeaningfulWork from '../subpages/live/MeaningfulWork.js';

import '../styles/Live.css';

function Print() {
  const {uid, page} = useParams();

  const renderPage = () => {
    if (page == 'live') {
      return <Output  user={uid}
                      dataLoaded={() => {}}
                      download={true} />;
    } else if (page == 'mw') {
      return <MeaningfulWork  user={uid}
                              download={true} />;
    } else if (page == 'prework') {
      return <Lived user={uid}
                    download={true} />;
    }
  };

  useEffect(() => {
    const footer = document.querySelector('footer');
    if (footer) {
      footer.style.display = 'none';
    }
  }, []);

  return (
    <>
      <div className='container-live'>
        {renderPage()}
      </div>
    </>
  );
}

export default Print;
